<template>
  <el-cascader
    v-model="values"
    :options="options"
    placeholder="请选择地区"
    size="small"
    :props="{
      value: 'value',
      label: 'text',
      children: 'children',
    }"
  />
</template>

<script>
export default {
  name: "AreaCascader",
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      options: [],
    };
  },
  created() {
    this.getAreaListData();
  },
  methods: {
    // 获取城市列表数据
    getAreaListData() {
      // const res = await this._api.userCurdApi.AreaGetListLevel();
      const areaData = this.$store.state.bases.GetListResult;
      const list = areaData.map((item) => {
        let children = [];
        if (item.ListArea?.length) {
          children = item.ListArea.map((child) => ({
            text: child.AreaName,
            value: child.AreaId,
          }));
        }
        return {
          text: item.AreaName,
          value: item.AreaId,
          children,
        };
      });
      this.options = list;
    },
  },
  computed: {
    values: {
      set(value) {
        if (value.length) {
          // 查找地区省级名称
          const province = this.options.find((item) => item.value === value[0]);
          // 查找地区市级名称
          const city = province.children.find(
            (item) => item.value === value[1]
          );
          const data = {
            provinceId: value[0],
            provinceName: province.text,
            cityId: value[1],
            cityName: city.text,
            text: `${province.text}/${city.text}`,
          };
          this.$emit("change", data);
        }
      },
      get() {
        return [this.$attrs?.value?.provinceId, this.$attrs?.value?.cityId];
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
